export default {"src":"https://web.cdn.greenlight.com/2.1355.2/_next/static/media/error_icon.bf9d3d38.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};